import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=03289270"
import script from "./Draggable.vue?vue&type=script&setup=true&lang=ts"
export * from "./Draggable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports